
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface WebNovelsErrorStateProps {
  error?: Error;
}

export const WebNovelsErrorState = ({ error }: WebNovelsErrorStateProps) => {
  return (
    <motion.div 
      className="container mx-auto py-8 text-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-md mx-auto">
        <AlertTriangle className="mx-auto h-12 w-12 text-destructive opacity-70 mb-4" />
        <h2 className="text-xl font-bold text-destructive mb-2">Erro</h2>
        <p className="text-muted-foreground mb-6">
          {error ? `${error.message}` : 'Não foi possível carregar a webnovel. Por favor, tente novamente mais tarde.'}
        </p>
        <Button 
          className="mt-4" 
          onClick={() => window.location.reload()}
          variant="outline"
        >
          Tentar novamente
        </Button>
      </div>
    </motion.div>
  );
};
